
import { useState } from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import CalendarSection from './components/CalendarSection';
import TeamsSection from './components/TeamsSection';
import ContactSection from './components/ContactSection';
import TabBar from './components/TabBar';

const HomePage = () => {
  const [activeTab, setActiveTab] = useState('inicio');

  const renderContent = () => {
    switch (activeTab) {
      case 'inicio':
        return <HeroSection />;
      case 'calendario':
        return <CalendarSection />;
      case 'equipos':
        return <TeamsSection />;
      case 'contacto':
        return <ContactSection />;
      default:
        return <HeroSection />;
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black">
      <Header activeTab={activeTab} setActiveTab={setActiveTab} />
      
      {/* Contenido principal con padding para header y tabbar */}
      <main className="pt-16 lg:pt-20 pb-20 lg:pb-8">
        {renderContent()}
      </main>
      
      {/* TabBar solo en móvil */}
      <div className="lg:hidden">
        <TabBar activeTab={activeTab} setActiveTab={setActiveTab} />
      </div>
    </div>
  );
};

export default HomePage;
